<mat-checkbox
  [attr.id]="id"
  [attr.name]="name"
  [color]="color"
  [checked]="checked"
  [disabled]="disabled"
  [indeterminate]="indeterminate"
  [labelPosition]="labelPosition"
  [disableRipple]="disableRipple"
  [required]="required"
  [value]="value"
  [tabIndex]="tabIndex"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-labelledby]="ariaLabelledby"
  [attr.aria-describedby]="ariaDescribedby"
  (change)="onCheckboxChange($event)"
  (indeterminateChange)="onIndeterminateChange($event)"
>
  <ng-content />
</mat-checkbox>
